// tslint:disable max-line-length
const env = process.env;

export const ACCESS_REQUEST_EXPIRATION_MINUTES = +(env.ACCESS_REQUEST_EXPIRATION_MINUTES || 15);
export const CHECK_ACCESS_INTERVAL_MS = +(env.CHECK_ACCESS_INTERVAL_MS || 1000);
export const CHIRP_APP_DOWNLOAD_ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.chirp.access';
export const CHIRP_APP_DOWNLOAD_IOS_URL = 'https://apps.apple.com/us/app/chirp-access/id1450159493';
export const CHIRP_APP_DOWNLOAD_MARKETING_URL = 'https://www.chirpsystems.com/app';
export const CHIRP_MARKETING_URL = 'https://www.chirpsystems.com';

// It would be better to use the deep link (chirpaccess://entry) for access approval instead
// of the universal link, but old versions of the Chirp mobile app don't support this.
// @TODO: Set up the mobile app to use the staging deep link.
export const CHIRP_UNIVERSAL_LINK = 'https://access.chirpsystems.com';

export const ENGRAIN_API_KEY = String(env.REACT_APP_ENGRAIN_API_KEY);
export const GRAPHQL_SERVER_SUBSCRIPTION_URL = String(env.REACT_APP_GRAPHQL_SERVER_SUBSCRIPTION_URL);
export const GRAPHQL_SERVER_URL = String(env.REACT_APP_GRAPHQL_SERVER_URL);

// Supports both Chirp and STRATIS URLs
export const QR_CODE_ALLOWED_ORIGINS = String(env.REACT_APP_QR_CODE_ALLOWED_ORIGINS || '')
  .split(',')
  .map(url => url.trim())
  .filter(Boolean);

export const REALPAGE_EULA_URL = 'https://www.realpage.com/smart-building-eula/';
export const REALPAGE_PATENT_MARKING = 'https://www.realpage.com/legal/patent-marking/';
export const REALPAGE_PRIVACY_POLICY_URL = 'https://www.realpage.com/privacy-policy/';
export const STRATIS_UNIVERSAL_LINK = String(env.REACT_APP_STRATIS_UNIVERSAL_LINK);
